<template>
  <div :class="['flex flex-col', itemsClass]">
    <h3 :class="['text-base font-semibold tracking-tight font-inter', textColorClass, alignClass]">
      <slot />
    </h3>
    <div v-if="underline" :class="['mt-2 rounded-full', underlineHeightClass, underlineWidthClass, underlineBgClass]"></div>
  </div>
  
</template>

<script>
export default {
  name: 'Header',
  props: {
    align: {
      type: String,
      default: 'center'
    },
    variant: {
      type: String,
      default: 'slate' // slate, indigo, blue, green, orange, rose
    },
    underline: {
      type: Boolean,
      default: false
    },
    underlineWidth: {
      type: String,
      default: 'sm' // sm, md, lg
    }
  },
  computed: {
    alignClass() {
      if (this.align === 'left') return 'text-left'
      if (this.align === 'right') return 'text-right'
      return 'text-center'
    },
    itemsClass() {
      if (this.align === 'left') return 'items-start'
      if (this.align === 'right') return 'items-end'
      return 'items-center'
    },
    textColorClass() {
      const map = {
        slate: 'text-gray-700',
        indigo: 'text-indigo-700',
        blue: 'text-blue-700',
        green: 'text-green-700',
        orange: 'text-orange-700',
        rose: 'text-rose-700'
      }
      return map[this.variant] || 'text-gray-700'
    },
    underlineBgClass() {
      const map = {
        slate: 'bg-slate-400',
        indigo: 'bg-indigo-500',
        blue: 'bg-blue-500',
        green: 'bg-green-500',
        orange: 'bg-orange-500',
        rose: 'bg-rose-500'
      }
      return map[this.variant] || 'bg-slate-400'
    },
    underlineWidthClass() {
      if (this.underlineWidth === 'lg') return 'w-24'
      if (this.underlineWidth === 'sm') return 'w-12'
      return 'w-16'
    },
    underlineHeightClass() {
      if (this.underlineWidth === 'lg') return 'h-1.5'
      if (this.underlineWidth === 'sm') return 'h-1'
      return 'h-1'
    }
  }
}
</script>

<style scoped>
.font-inter {
  font-family: 'Inter', ui-sans-serif, system-ui, -apple-system, Segoe UI,
    Roboto, Noto Sans, Ubuntu, Cantarell, Helvetica Neue, Arial, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", sans-serif;
}
</style>


